import React from 'react'
import styled from 'styled-components'
import { IndustryIcon } from '..'
import { IndustryCategory } from '../../domain'
import { ListItemProps, ListItem } from '../ListItem'

export interface ListItemWithIndustryIconProps extends Omit<ListItemProps, 'adornment'> {
  industryCategory?: IndustryCategory
  truncatedTextLength?: number | undefined
}

export const ListItemWithIndustryIcon: React.FC<ListItemWithIndustryIconProps> = ({
  industryCategory,
  text,
  truncatedTextLength,
  ...rest
}) => {
  const truncatedText =
    truncatedTextLength && text.length >= truncatedTextLength
      ? `${text.substring(0, truncatedTextLength - 3)}...`
      : text

  return (
    <ListItem
      {...rest}
      text={truncatedText}
      adornment={
        <IconContainer>
          <IndustryIcon
            industryCategory={industryCategory}
            imageStyle={{ maxWidth: '100%', maxHeight: '100%' }}
            {...rest}
          />
        </IconContainer>
      }
    />
  )
}

const IconContainer = styled.div`
  width: 4rem;
  min-width: 4rem;
  text-align: center;
  margin: 0.8rem;
  height: 2.8rem;
`
